<template>
    <rkm-area
        v-if="model"
        no-margin-top
        title="Certificado digital"
        type="fieldset"
    >
        <rkm-form
            v-if="items.length === 0"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-file
                        :validations="validations.certificadoDigital"
                        accept=".pfx"
                        label="Certificado digital (A1 .PFX)"
                        v-model="model.certificadoDigital"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :disabled="!model.certificadoDigital"
                        :validations="validations.senha"
                        label="Senha"
                        type="password"
                        v-model="model.senha"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-else
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(actions)>
                <rkm-button
                    @click="download"
                    color="info"
                    small
                    title="Download das evidências"
                >
                    <rkm-icon icon="download" />
                </rkm-button>

                <rkm-button
                    @click="destroy"
                    authorize="destroy-integracao-cns-parametrizacao"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import {error, repository, stringCase, certificadoDigital} from '@/mixins'

// Others.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                certificadoDigital: {required: true},
                senha: {
                    required: true,
                    min: 1,
                    max: 100,
                },
            }
        }
    },
    created() {
        this.repositories = {
            cns: this.getConectaSusRepository('integracao.cns.cns'),
            parametrizacao: this.getConectaSusRepository('integracao.cns.parametrizacao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'certificadoDigital', label: 'Certificado digital'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        items: [],
        additionals: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.parametrizacao.index()
                .then(response => {
                    this.items = Object.assign(response.data)
                    this.$emit('loaded', this.items.length === 0)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        create() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)

                    this.exibirAvisoValidadeCertificadoDigital(this.additionals.dadosCertificadoDigital)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            const request = new FormData()

            request.append('certificado_digital', this.model.certificadoDigital)
            request.append('senha', this.model.senha)

            this.setLoading()

            this.repositories.parametrizacao.store(request)
                .then(() => {
                    this.showSaveNotification()
                    this.$emit('saved')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return

                    this.store()
                })
        },
        destroy() {
            this.showDeleteConfirmation('Deseja realmente excluir o certificado digital?', async () => {
                this.setLoading()

                this.repositories.parametrizacao.destroy()
                    .then(() => this.$emit('destroyed'))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        download() {
            this.setLoading()

            this.repositories.parametrizacao.download()
                .then(response => {
                    const blob = new Blob([response.data], {type: "application/pdf"})
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = 'EVIDENCIAS.PDF'
                    link.click()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase, certificadoDigital],
    mounted() {
        Promise.all([
            this.load(),
            this.create(),
        ])
    },
    watch: {
        'model.certificadoDigital'() {
            this.model.senha = null
        },
    },
}
</script>